import React, { useState } from 'react';
import { SimpleTag } from '@atlaskit/tag';
import Button from '@atlaskit/button';
import Badge from '@atlaskit/badge';
import Popup from '@atlaskit/popup';
import styled from '@emotion/styled';
import { Box, Flex, xcss } from '@atlaskit/primitives';
import { BILLED_EXTERNALLY } from '@css-xp/ppc-constants';

const StyledBadge = styled.div`
  > button {
    text-decoration: none;
    background: none;

    &:active {
      text-decoration: none;
      background: none;
    }
  }
`;

const tagsStyle = xcss({
  padding: 'space.100',
});

export interface EntitlementTagsProps {
  isAddOn?: boolean;
  isSandbox?: boolean;
  isExternallyBilled?: boolean;
  isInternalUsageLicenseEntitlement?: boolean;
  isEntitlementOnGracePeriod?: boolean;
  isBilledElsewhere?: boolean;
}

export const EntitlementTags = ({
  isAddOn,
  isSandbox,
  isExternallyBilled,
  isInternalUsageLicenseEntitlement,
  isEntitlementOnGracePeriod,
  isBilledElsewhere,
}: EntitlementTagsProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const tagList = [
    { label: 'Add-On', value: isAddOn },
    { label: 'Sandbox', value: isSandbox },
    { label: BILLED_EXTERNALLY, value: isExternallyBilled },
    { label: 'Internal Use License', value: isInternalUsageLicenseEntitlement },
    { label: 'Grace Period', value: isEntitlementOnGracePeriod },
    { label: 'Billed elsewhere', value: isBilledElsewhere },
  ];
  const activeTags = tagList?.filter((tag) => tag.value);
  const primaryTag = activeTags[0];
  const additionalTags = activeTags.slice(1);
  return (
    <Flex alignItems="center">
      {primaryTag && <SimpleTag text={primaryTag.label} testId="billed-externally-text-with-tooltip" />}
      {additionalTags?.length >= 1 && (
        <Popup
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          placement="bottom"
          content={() => (
            <Box xcss={tagsStyle}>
              <Flex>
                {additionalTags.map((tag, index) => (
                  <SimpleTag key={index} text={tag.label} testId="billed-externally-text-with-tooltip" />
                ))}
              </Flex>
            </Box>
          )}
          testId="quote-details-popup"
          trigger={(triggerProps: any) => (
            <StyledBadge>
              <Button
                {...triggerProps}
                appearance="subtle"
                isSelected={isOpen}
                className="stale-status stale-reason-container"
                testId="stale-quote-warning-icon"
                onClick={() => setIsOpen(true)}
                style={{ backgroundColor: isOpen ? 'transparent' : undefined }}
              >
                <Badge>{`+${additionalTags.length}`}</Badge>
              </Button>
            </StyledBadge>
          )}
        />
      )}
    </Flex>
  );
};
